var lib_core = require("lib-core");

var VersionsView = require("./versionsView.js");
var VersionsModel = require("./versionsModel.js");
var VersionsStateMachine = require("./versionsStateMachine.js");

var MasterController = require("./../master/masterController.js");
var SidebarController = require("./../sidebar/sidebarController.js");
var ConnectionMessageController = require("./../connectionMessage/connectionMessageController.js");

var VersionsController = function(archLayers, dependencies, configuration) {
    lib_core.GuiEvents.addEvents({
        CREATE_VERSION_VERSIONSIDEBAR: {id: 'vsdbr_1', name: "CREATE_VERSION_VERSIONSIDEBAR"},
        TOGGLE_DRAFT_VERSIONSIDEBAR:   {id: 'vsdbr_2', name: "TOGGLE_DRAFT_VERSIONSIDEBAR"},
        SHOW_DRAFT_VERSIONSIDEBAR:     {id: 'vsdbr_3', name: "SHOW_DRAFT_VERSIONSIDEBAR"}
    });

    if(configuration && configuration.preCheckBeforeVersionCreation) {
        lib_core.GuiEvents.addEvents({
            PRECHECK_BEFORE_VERSION_CREATION: {id: 'vsdbr_4', name: "PRECHECK_BEFORE_VERSION_CREATION"}
        });
    }

    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};

lib_core.inherit(VersionsController, lib_core.Controller);
VersionsController.inject = {
    masterController : MasterController,
    sidebarController : SidebarController,
    connectionMessageController: ConnectionMessageController
};

VersionsController.prototype.beforeLoad = function () {
    var self = this;
    if (this.configuration.groups) {
        this.configuration.groups.forEach(function(groupConfig) {
            self.getView().addGroup(groupConfig);
        });
    }
    lib_core.Controller.prototype.beforeLoad.call(this);
};

VersionsController.prototype.afterLoad = function () {
    var self = this;
    var stateMachineCreator = function(){
        return self.createStateMachine();
    };
    this.masterController.getStatemachine().append(this.name(), stateMachineCreator, /.*/, null, lib_core.StateMachine.CIRCULAR, null);
};

VersionsController.prototype.createView = function () {
    return new VersionsView(this.getModel(), this.rootStateMachine, this.sidebarController && this.sidebarController.getView(), this.masterController.getView(), this.configuration);
};

VersionsController.prototype.createModel = function () {
    return new VersionsModel(this.root, this.sidebarController && this.sidebarController.getModel(), this.configuration);
};

VersionsController.prototype.createStateMachine = function () {
    return new VersionsStateMachine(this.root, this.getModel());
};

module.exports = VersionsController;
